import { Progress } from "antd";
import styled from "styled-components";

const ProgressStyled = styled(Progress)``;

export default ProgressStyled;
